/**
 * Created by chao.z on 18/3/16.
 */
export const CHANGE_HEIGHT = 'CHANGE_HEIGHT';

export const changeHeight = (obj) => ({
  type: CHANGE_HEIGHT,
  obj
});


// WEBPACK FOOTER //
// ./src/actions/nutrition.js